import React, { Component } from 'react';
import { Button } from 'antd';
import { InfoWrapper } from './style';

import {
	WALLET_ENTERPRISE_PACK,
	WALLET_BUSINESS_PACK
} from '../../config/media';

class UpgradeInfo extends Component {
	state = {
		type: this.props.type
	};

	handleChange = (num) => {
		this.setState({ type: num });
	};

	handleArrow = (num) => {
		this.setState({ type: Math.abs((this.state.type + num) % 3) });
	};

	renderInfos = () => {
		const { type } = this.state;
		if (type === 0) {
			return (
				<div className="vault-info">
					<img
						className="vault-info-img"
						src={WALLET_BUSINESS_PACK}
						alt="business wallet"
					/>
					<div className="vault-info-desc">
						<h4>Lite Wallet Features</h4>
						<p>• Supports BTC, ETH, XRP and BCH</p>
						<p>• Supports ERC-20</p>
						<p>• Unlimited deposits and withdrawals</p>
						<p>• Webhook enabled</p>
						<p>• Dashboard access</p>
						<p>• Seed backup</p>
						<div className="cost-box">
							<b>Free:</b> /mo
						</div>
					</div>
				</div>
			);
		} else if (type === 1) {
			return (
				<div className="vault-info">
					<img
						className="vault-info-img"
						src={WALLET_BUSINESS_PACK}
						alt="business wallet"
					/>
					<div className="vault-info-desc">
						<h4>Business Wallet Features</h4>
						<p>• Multiple coin wallets</p>
						<p>• Master and sub accounts</p>
						<p>• Unlimited address generation</p>
						<p>• Programmatic remote access</p>
						<p>• Automatic address sweeping</p>
						<p>• Batching transactions</p>
						<div className="cost-box">
							<b>$1,950</b> /mo
						</div>
					</div>
				</div>
			);
		}
		return (
			<div className="vault-info">
				<img
					className="vault-info-img"
					src={WALLET_ENTERPRISE_PACK}
					alt="Enterprise_Wallet"
				/>
				<div className="vault-info-desc">
					<h4>Enterprise Wallet Feature</h4>
					<p>• Stored in IBM Crypto Express 6S HSM</p>
					<p>• High transaction volumes</p>
					<p>• Beyond-bank-grade security</p>
					<p>• On-premise setup</p>
					<div className="cost-box">
						<b>TBA</b> /mo
					</div>
				</div>
			</div>
		);
	};

	render() {
		const { type } = this.state;
		const { onCancel, onOk } = this.props;
		return (
			<InfoWrapper>
				<div
					className="arrow left"
					onClick={() => {
						this.handleArrow(-1);
					}}
				/>
				<div
					className="arrow right"
					onClick={() => {
						this.handleArrow(1);
					}}
				/>
				{this.renderInfos()}
				<div className="btn-area">
					<Button onClick={onCancel}>Back</Button>
					<Button
						type="primary"
						onClick={() => {
							onOk(type);
						}}
					>
						Get Started
					</Button>
				</div>
			</InfoWrapper>
		);
	}
}

export default UpgradeInfo;
